<template>
  <span class="crlv-hint" :title="helpText" :aria-label="helpTitle">?</span>
</template>

<script>
  import { CRLV_HELP_TEXT, CRLV_HELP_TITLE } from '@/utils/crlvHelp'

  export default {
    name: 'CrlvHint',
    computed: {
      helpText() {
        return CRLV_HELP_TEXT
      },
      helpTitle() {
        return CRLV_HELP_TITLE
      }
    }
  }
</script>

<style scoped>
  .crlv-hint {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    border-radius: 50%;
    background: #d3d6de;
    color: #051b30;
    font-size: 11px;
    font-weight: 600;
    cursor: help;
    margin-left: 4px;
    vertical-align: middle;
  }
</style>
